import styled from 'styled-components';
export const AvatarWrapper = styled.img `
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border-radius: var(--border-radius-circle, 50%);
  background-color: var(--color-neutral-80);
`;
